module.exports = __webpack_public_path__ + "img/top.3ce33e20.png";